/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;
  var placeholder_image = document.getElementsByTagName("body")[0].getAttribute("data-placeholder-image");

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price),
        discount_ratio = 1.0 - price_ratio,
        res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res = '<b class="on_sale">' + formatPrice(price) + '</b>';
      res += ' <s class="round-5 ais-hit--price-striked">' + formatPrice(compare_at_price) + '</s> ';
      res += ' <span class="ais-hit--price-discount">-' + Math.round(discount_ratio * 100) + '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  // Parse a metafield date value (e.g. "2026-03-05" or "2026-03-05 00:00:00") to a local Date.
  const parseProductDate = function parseProductDate(value) {
    if (!value) {
      return null;
    }
    const datePart = String(value).trim().split('T')[0].split(' ')[0];
    const parts = datePart.split('-');
    if (parts.length === 3) {
      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const day = Number(parts[2]);
      if (year && month && day) {
        return new Date(year, month - 1, day);
      }
    }
    const fallback = new Date(String(value));
    return isNaN(fallback.getTime()) ? null : fallback;
  };

  const getISOWeek = function getISOWeek(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  };

  // Mirrors the "week/year" logic in snippets/product-shipping-availability.liquid.
  // Foreign books get a 10-day processing margin, others 4 days.
  const formatAvailabilityWeek = function formatAvailabilityWeek(value, isForeign) {
    const base = parseProductDate(value);
    if (!base) {
      return '';
    }
    const marginDays = isForeign ? 10 : 4;
    const d = new Date(base.getTime() + marginDays * 86400000);
    const week = getISOWeek(d);
    const month = d.getMonth() + 1;
    let year = d.getFullYear();
    if (week === 1 && month === 12) {
      year += 1;
    }
    return week + '/' + year;
  };

  const formatAvailabilityDate = function formatAvailabilityDate(value) {
    const d = parseProductDate(value);
    if (!d) {
      return '';
    }
    return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
  };

  const hasTag = function hasTag(tags, needle) {
    if (!tags || !tags.length) {
      return false;
    }
    const lower = needle.toLowerCase();
    return tags.some(function(tag) {
      return String(tag).toLowerCase().indexOf(lower) !== -1;
    });
  };

  // Digital products (e-books, audiobooks) have no physical pickup availability.
  algolia.isDigitalProduct = function isDigitalProduct(product) {
    const availability = product.meta && product.meta.woolman && product.meta.woolman.availability;
    if (typeof availability === 'string' && availability.toUpperCase() === 'SKHETI') {
      return true;
    }

    const digitalProductTypes = ['e-kirja', 'äänikirja', 'digikirja', 'lahjakortti'];

    if (typeof product.product_type === 'string') {
      const type = product.product_type.trim().toLowerCase();
      if (digitalProductTypes.includes(type)) {
        return true;
      }
    }

    return false;
  };

  // Mimics the server-side shipping availability calculation in
  // snippets/product-shipping-availability.liquid using Algolia index data.
  algolia.getShippingAvailabilityText = function getShippingAvailabilityText(product) {
    const translations = (algolia.translations && algolia.translations.skAvailability) || {};
    const tags = product.tags || [];

    if (hasTag(tags, 'saatavilla vain myymälöistä')) {
      return (algolia.translations && algolia.translations.unavailableForShipping) || '';
    }

    const meta = (product.meta && product.meta.woolman) || {};
    const sk = meta.availability ? String(meta.availability).toLowerCase() : '';
    if (!sk) {
      return '';
    }

    const info = meta.product_info || {};
    const publicationDate = info.PublicationDate;
    const reprintDate = info.ForthcomingReprintDate;
    const isForeign = hasTag(tags, 'tuotepääryhmä:ulkomaiset kirjat');
    const isEmbargo = hasTag(tags, 'kokoelma:embargo');

    // sk100/sk150 messages depend on product_info dates; skip if that metafield isn't indexed.
    if ((sk === 'sk100' || sk === 'sk150') && !meta.product_info) {
      return '';
    }

    let key;
    if (sk === 'sk100' && !publicationDate) {
      key = 'sk100_unknown_date';
    } else if (sk === 'sk150' && !reprintDate) {
      key = 'sk150_unknown_date';
    } else if (sk === 'sk100' && algolia.isDigitalProduct(product)) {
      key = 'sk100_digital';
    } else if (sk === 'sk150' && algolia.isDigitalProduct(product)) {
      key = 'sk150_digital';
    } else if (sk === 'sk100' && isEmbargo) {
      key = 'sk100_embargo';
    } else if (sk === 'sk150' && isEmbargo) {
      key = 'sk150_embargo';
    } else {
      key = sk;
    }

    const text = translations[key];
    if (typeof text !== 'string' || !text) {
      return '';
    }

    return text
      .replace('__PUBLICATION_WEEK__', formatAvailabilityWeek(publicationDate, isForeign))
      .replace('__REPRINT_WEEK__', formatAvailabilityWeek(reprintDate, isForeign))
      .replace('__PUBLICATION_DATE__', formatAvailabilityDate(publicationDate))
      .replace('__REPRINT_DATE__', formatAvailabilityDate(reprintDate));
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    typeClass: function typeClass () {
      if (this.product_type == 'E-kirja') {
        return ('e-book');
      } else if (this.product_type == 'Äänikirja') {
        return ('audio-book');
      }
    },
    loyaltyPrice: function loyaltyPrice (text, render) {
      if (this.tags.length > 0) {
        for (let i = 0; i < this.tags.length; i++) {
          if (this.tags[i].toLowerCase().indexOf("loyal|") !== -1 && this.tags[i].split("|")[1] === this.sku) {
             return '<span class="aa-product-price__loyalty loyalty-price"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-loyalty-price-full-color" id="Layer_1" data-name="Layer 1" viewBox="55 80 190 140"><defs><style>.loyalty-price-cls-1{fill:#000;}.loyalty-price-cls-1,.loyalty-price-cls-2{stroke-width:0px;}.loyalty-price-cls-2{fill:#fff;}</style></defs><path class="loyalty-price-cls-1" d="M235.3,220c-.7-6.3-2.1-12.1-3.8-17.3-6.2-18.6-16.9-29.7-16.9-29.7,9.1-12,7.7-29.9,7.7-29.9-.3-16.8-11.3-28.4-11.3-28.4,5.9-19.2,1.1-33.8,1.1-33.8-12.4,10-26.6,13.8-34,14.8s-5.1.6-5.1.6c-14.3-3.4-22.5-3.1-22.5-3.1h0s-8.2-.3-22.5,3.1c0,0-1.7-.2-5.1-.6-7.4-1-21.5-4.8-34-14.8,0,0-4.8,14.7,1.1,33.8,0,0-11,11.6-11.3,28.4,0,0-1.4,17.8,7.7,29.9,0,0-10.7,11.2-16.9,29.7-1.7,5.1-3.1,10.8-3.8,16.9l169.7.4Z"/><path class="loyalty-price-cls-2" d="M150.5,144c-5.9-13.6-13.4-21.8-23.4-25-15.8-5.1-32.7,3.6-37.8,19.4-5.1,15.8,3.5,32.8,19.4,37.8,15.6,4.9,39.2-8.6,39.2-8.6l-3.5,10.6,6.2,12.2,6.2-12.2-3.5-10.6s23.6,13.5,39.2,8.6c15.8-5,24.4-22,19.4-37.8-5.1-15.8-22-24.4-37.8-19.4-10,3.2-17.5,11.4-23.4,25h0Z"/><path class="loyalty-price-cls-1" d="M101.2,135.6l.3,1.2c1.7,5.2,7.2,8,12.3,6.3,5.2-1.7,8-7.2,6.3-12.3-.7-2.1-2-3.8-3.7-5h.7c9.4-.8,18.4,4.9,21.4,14.2,3.5,10.9-2.5,22.6-13.4,26.1-10.9,3.5-22.6-2.5-26.1-13.4-1.9-5.9-1-12,1.9-16.9l.3-.3Z"/><path class="loyalty-price-cls-1" d="M164.5,135.6l.3,1.2c1.7,5.2,7.2,8,12.3,6.3,5.2-1.7,8-7.2,6.3-12.3-.7-2.1-2-3.8-3.7-5h.7c9.4-.8,18.4,4.9,21.4,14.2s-2.5,22.6-13.4,26.1c-10.9,3.5-22.6-2.5-26.1-13.4-1.9-5.9-1-12,1.9-16.9l.3-.3Z"/></svg>' + this.tags[i].split("|")[2].replace(".",",") + ' €</span>'
          }
          if (this.tags[i].toLowerCase().indexOf("loyalty_gold|") !== -1 && this.tags[i].split("|")[1] === this.sku) {
            return '<span class="aa-product-price__loyalty-gold loyalty-gold-price"><svg id="Layer_1" data-name="Layer 1" viewBox="0 0 1027.52 1027.52" aria-hidden="true" focusable="false" role="presentation" class="icon icon-kultaetumerkki-full-color icon--full-color"><defs><style>.kultaetumerkki-circle{fill:#821746}.kultaetumerkki-path{fill:#fff}</style></defs><circle class="kultaetumerkki-circle" cx="513.76" cy="513.76" r="513.76"></circle><path class="kultaetumerkki-path" d="M165.23,254.57s208.8,58.44,312.03,189.66c1.66,2.1-.73,4.22.87,6.37,5.3,9.2,16.43,11.19,27.86,11.55,9.97.31,20.37-1.8,27.9-4.72,4.86-1.89,7.24-4.97,8.23-9.96,0,0,65.26-99.14,318.66-191.87,2.29,26.71-.25,50.88-.25,50.88,0,0,.13,12.72-27.73,18.57-15.33,3.22-73.06,25.74-132,53.44-65.49,30.77-146.75,87.26-144.55,113.84-.17,38.04-27.65,36.17-27.65,36.17,0,0-40.79,1.67-51.48-1.95s-8.69-20.69-16.71-36.72-23.07-34.21-66.49-62.03c-159.43-102.14-217.72-107.31-227.79-117.76-8.99-9.33-.89-55.46-.89-55.46Z"></path><path class="kultaetumerkki-path" d="M167.19,403.15s208.8,58.44,312.03,189.66c1.66,2.1-.73,4.22.87,6.37,5.3,9.2,16.43,11.19,27.86,11.55,9.97.31,20.37-1.8,27.9-4.72,4.86-1.89,7.24-4.97,8.23-9.96,0,0,65.26-99.14,318.66-191.87,2.29,26.71-.25,50.88-.25,50.88,0,0,.13,12.72-27.73,18.57-15.33,3.22-73.06,25.74-132,53.44-65.49,30.77-146.75,87.26-144.55,113.84-.17,38.04-27.65,36.17-27.65,36.17,0,0-40.79,1.67-51.48-1.95-10.69-3.62-8.69-20.69-16.71-36.72-8.01-16.03-23.07-34.21-66.49-62.03-159.43-102.14-217.72-107.31-227.79-117.76-8.99-9.33-.89-55.46-.89-55.46Z"></path><path class="kultaetumerkki-path" d="M165.23,540.3s208.8,58.44,312.03,189.66c1.66,2.1-.73,4.22.87,6.37,5.3,9.2,16.43,11.19,27.86,11.55,9.97.31,20.37-1.8,27.9-4.72,4.86-1.89,7.24-4.97,8.23-9.96,0,0,65.26-99.14,318.66-191.87,2.29,26.71-.25,50.88-.25,50.88,0,0,.13,12.72-27.73,18.57-15.33,3.22-73.06,25.74-132,53.44-65.49,30.77-146.75,87.26-144.55,113.84-.17,38.04-27.65,36.17-27.65,36.17,0,0-40.79,1.67-51.48-1.95-10.69-3.62-8.69-20.69-16.71-36.72-8.01-16.03-23.07-34.21-66.49-62.03-159.43-102.14-217.72-107.31-227.79-117.76-8.99-9.33-.89-55.46-.89-55.46Z"></path></svg>' + this.tags[i].split("|")[2].replace(".",",") + ' €</span>';
          }
        }
      };
    },
    isLoyaltyProduct: function isLoyaltyProduct (text, render) {
      if (this.tags.length > 0) {
        for (let i = 0; i < this.tags.length; i++) {
          if (this.tags[i].toLowerCase().indexOf("loyal|") !== -1 && this.tags[i].split("|")[1] === this.sku) {
             return render( text.replace('0', this.tags[i].split("|")[2].replace(".",",")) )
          }
        }
      };    
      return render('');
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        '?' +
        (addVariantId ? 'variant=' + this.objectID + '&' : '') +
        'queryId=' + this.queryID +
        '&objectId=' + this.objectID
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return placeholder_image;
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    checkProductStatus: function checkProductStatus (){
      var orderButton;
      if(typeof(this.meta.woolman) != 'undefined' && this.meta.woolman.availability == 'SK100'){
        orderButton = '<input type="submit" value="[[ translations.preOrder ]]" class="button small primary add-to-cart"/>';
      }else if(typeof(this.meta.woolman) != 'undefined' && this.meta.woolman.availability == 'SK150'){
        orderButton = '<input type="submit" value="[[ translations.preOrder ]]" class="button small primary add-to-cart"/>';
      }else if(this.product_type == 'Äänikirja'){
        orderButton = '<input type="submit" value="[[ translations.addToCartAudiobook ]]" data-sk-availability="' + this.meta.woolman.availability.toLowerCase() + '" class="button small primary add-to-cart"/>';
      }else if(this.product_type == 'E-kirja'){
        orderButton = '<input type="submit" value="[[ translations.addToCartEbook ]]" data-sk-availability="' + this.meta.woolman.availability.toLowerCase() + '" class="button small primary add-to-cart"/>';
      }else if(this.product_type == 'Digikirja'){
        orderButton = '<input type="submit" value="[[ translations.addToCartDigibook ]]" data-sk-availability="' + this.meta.woolman.availability.toLowerCase() + '" class="button small primary add-to-cart"/>';
      }else{
        orderButton = '<input type="submit" value="[[ translations.addToCart ]]" class="button small primary add-to-cart"/>';
      }
      return orderButton;
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return placeholder_image;
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
